export default __webpack_public_path__ + "static/media/location-feed-icon.5dae8494.svg";